module.exports = __webpack_public_path__ + "img/30.2099e457.jpg";